import React from "react";
import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { WithdrawalResponseItem } from "@api-types/withdrawal";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { WithdrawalHistoryTableItem } from "@features/payment/withdrawal/desktop/my-withdrawals/table";
import { WithdrawalContext } from "@state/context/payment/WithdrawalContext";
import { observer } from "mobx-react";

export default observer(function MyWithdrawalsTable() {
	const { t } = useTranslation("payment");

	const { withdrawalList } = useContext(WithdrawalContext);

	if (withdrawalList == null) {
		return null;
	}

	if (withdrawalList.item.length === 0) {
		return (
			<InfoMessageComponent
				type="note"
				message={t<string>("COMMON.TABLE.EMPTY")}
				addClassName="u-mar--top--med"
				textClass="message__text"
			/>
		);
	}

	return (
		<table className="table--primary table--shadowy u-mar--top--med">
			<thead className="table--primary__header table--primary__header--light">
				<tr className="table--primary__header__row">
					<th className="table--primary__header__data">ID</th>
					<th className="table--primary__header__data">
						{t<string>("COMMON.TABLE.HEADER.AMOUNT")}
					</th>
					<th className="table--primary__header__data">
						{t<string>("COMMON.TABLE.HEADER.METHOD")}
					</th>
					<th className="table--primary__header__data">
						{t<string>("COMMON.TABLE.HEADER.START_DATE")}
					</th>
					<th className="table--primary__header__data">
						{t<string>("COMMON.TABLE.HEADER.END_DATE")}
					</th>
					<th className="table--primary__header__data u-type--center">
						{t<string>("COMMON.TABLE.WALLET")}
					</th>
					<th className="table--primary__header__data">
						{t<string>("COMMON.TABLE.HEADER.STATUS")}
					</th>
				</tr>
			</thead>
			<tbody className="table--primary__body">
				{withdrawalList.item.map(
					(withdrawalHistoryItem: WithdrawalResponseItem) => {
						return (
							<WithdrawalHistoryTableItem
								key={withdrawalHistoryItem.id}
								withdrawalHistoryItem={withdrawalHistoryItem}
							/>
						);
					}
				)}
			</tbody>
		</table>
	);
});
